import { render } from "./TitleH1.vue?vue&type=template&id=5089dc04&scoped=true"
import script from "./TitleH1.vue?vue&type=script&lang=js"
export * from "./TitleH1.vue?vue&type=script&lang=js"

import "./TitleH1.vue?vue&type=style&index=0&id=5089dc04&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5089dc04"]])

export default __exports__